/**
 * Canonical application routes — single source of truth for router and navigation.
 */
export const APP_ROUTES = {
  dashboard: {
    overview: '/dashboard/overview',
    /** @deprecated Use APP_ROUTES.reports.locationHealth — kept for redirects. */
    reports: '/dashboard/reports',
  },
  reports: {
    locationHealth: '/reports/location-health',
    dependencyBlockers: '/reports/dependency-blockers',
    sCurve: '/reports/s-curve',
  },
  schedule: {
    import: '/schedule/import',
    locations: '/schedule/locations',
    tasks: '/schedule/tasks',
    baselines: '/schedule/baselines',
    calendar: '/schedule/calendar',
    resources: '/schedule/resources',
  },
  requestTracking: '/request-tracking',
  error: '/error',
  logout: '/logout',
} as const;

export const DASHBOARD_HUB_PATHS = [APP_ROUTES.dashboard.overview] as const;

export const REPORTS_HUB_PATHS = [
  APP_ROUTES.reports.locationHealth,
  APP_ROUTES.reports.dependencyBlockers,
  APP_ROUTES.reports.sCurve,
] as const;

export const SCHEDULE_HUB_PATHS = [
  APP_ROUTES.schedule.import,
  APP_ROUTES.schedule.locations,
  APP_ROUTES.schedule.tasks,
  APP_ROUTES.schedule.baselines,
  APP_ROUTES.schedule.calendar,
  APP_ROUTES.schedule.resources,
] as const;

export type DashboardViewId = 'overview';

export type ReportsViewId = 'location-health' | 'dependency-blockers' | 's-curve';

export function normalizePathname(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/';
}

export function isDashboardHubActive(pathname: string): boolean {
  const p = normalizePathname(pathname);
  return (DASHBOARD_HUB_PATHS as readonly string[]).includes(p) || p === '/dashboard';
}

export function getDashboardViewFromPath(_pathname: string): DashboardViewId {
  return 'overview';
}

export function isDashboardSubnavActive(
  itemId: DashboardViewId,
  pathname: string
): boolean {
  const p = normalizePathname(pathname);
  if (itemId === 'overview') {
    return p === APP_ROUTES.dashboard.overview || p === '/dashboard';
  }
  return false;
}

export function isReportsHubActive(pathname: string): boolean {
  const p = normalizePathname(pathname);
  return (
    (REPORTS_HUB_PATHS as readonly string[]).includes(p) ||
    p === '/reports' ||
    p === APP_ROUTES.dashboard.reports
  );
}

export function isReportsSubnavActive(itemId: ReportsViewId, pathname: string): boolean {
  const p = normalizePathname(pathname);
  if (itemId === 'location-health') {
    return p === APP_ROUTES.reports.locationHealth || p === APP_ROUTES.dashboard.reports;
  }
  if (itemId === 'dependency-blockers') {
    return p === APP_ROUTES.reports.dependencyBlockers;
  }
  if (itemId === 's-curve') {
    return p === APP_ROUTES.reports.sCurve;
  }
  return false;
}

export function isScheduleHubActive(pathname: string): boolean {
  const p = normalizePathname(pathname);
  return (SCHEDULE_HUB_PATHS as readonly string[]).includes(p);
}
